import { defineAbilityForPermissions } from "@/configuration/ability";
import { abilitiesPlugin } from "@casl/vue";

export const ability = defineAbilityForPermissions([]);

export const can = {
  install(Vue) {
    Vue.use(abilitiesPlugin, ability);
  },
};
